export const onError = (errors, e) => {
  const concatErrors = Object.keys(errors).map((key) => {
    const error = errors[key];
    return `${key.toLowerCase()}_${error.type}`;
  }).join(',');

  if (typeof window.TC?.gaEvent === 'function') {
    window.TC?.gaEvent(e.target.name, 'error', concatErrors);
  }
};

export const pushGaEvent = (category, action, label, value = '') => {
  const dataLayerAvailable = Array.isArray(window.dataLayer);

  if (!dataLayerAvailable) {
    console.warn('Tracking DataLayer not available');
    return;
  }

  var tracking = {
    event: 'gaEvent',
    eventSyntax: {
      action: action,
      category: category,
      value: value,
      label: label
    }
  };

  window.dataLayer.push(tracking);
};

// format string from e.g. 'Populære spil' to 'populaere_spil'
export var formatString = (str) => {
  str = str.replace(/\s+/g, '_').toLowerCase();
  str = str.replace(/æ/g, 'ae');
  str = str.replace(/ø/g, 'oe');
  str = str.replace(/å/g, 'aa');
  return str;
};

export const pushGaEventOnPageRedirect = (category, action, label) => {
  localStorage.setItem('localStorageGaEventTracking', JSON.stringify({
    category: category,
    action: action,
    label: label,
  }));
};

export const getGaEventAfterPageRedirect = () => {
  var ls = localStorage.getItem('localStorageGaEventTracking');
  if (ls) {
    ls = JSON.parse(ls);
    if (ls.category !== null
        && ls.action !== null
        && ls.label !== null) {
      pushGaEvent(ls.category, ls.action, ls.label);
    }
    localStorage.removeItem('localStorageGaEventTracking');
  }
};

export const pushGaEventVirtualPage = (name, virtualPath) => {
  const dataLayerAvailable = Array.isArray(window.dataLayer);

  if (!dataLayerAvailable) {
    console.warn('Tracking DataLayer not available');
    return;
  }

  var tracking = {
    event: 'virtualPage',
    page: {
      name: name,
      virtualPath: virtualPath
    }
  };

  window.dataLayer.push(tracking);
};

export const pushGaEventVirtualPageOnPageRedirect = (name, virtualPath) => {
  let vp = '/virtualpath/' + virtualPath;
  localStorage.setItem('localStorageGaEventVirtualPageTracking', JSON.stringify({
    name: name,
    virtualPath: vp
  }));
};

export const getGaEventVirtualPageAfterPageRedirect = () => {
  var ls = localStorage.getItem('localStorageGaEventVirtualPageTracking');
  if (ls) {
    ls = JSON.parse(ls);
    if (ls.name !== null
      && ls.virtualPath !== null) {
      pushGaEventVirtualPage(ls.name, ls.virtualPath);
    }
    localStorage.removeItem('localStorageGaEventVirtualPageTracking');
  }
};

export const pushHeroTrackingEvent = (eventType, bannerName) => {
  const dataLayerAvailable = Array.isArray(window.dataLayer);

  if (!dataLayerAvailable) {
    console.warn('Tracking DataLayer not available');
    return;
  }

  var tracking = {
    event: eventType,
    ecommerce: {
      [eventType]: {
        promotions: [{
          name: 'tivo',
          position: 'hero_banner',
          creative: bannerName
        }]
      }
    }
  };

  window.dataLayer.push(tracking);
};

export const initTracking = () => {
  const dataLayerAvailable = Array.isArray(window.dataLayer);

  const pushVirtualPage = function(name, path, type) {
    if (!dataLayerAvailable) {
      console.warn('Tracking DataLayer not available');
      // No reason to do any furhter if dataLayer is not available or method is called without an object
      return;
    }

    const pushEvent = {
      event: 'virtualPage',
      page: {
        name: name.trim(),
        virtualPath: '/virtualPath' + path ? path.toLowerCase() : '',
        type: type ? type.toLowerCase() : ''
      }
    };

    window.dataLayer.push(pushEvent);
  };

  const userEvent = function(userObj) {
    if (!dataLayerAvailable || (typeof userObj === 'undefined' && !userObj)) {
      // No reason to do any furhter if dataLayer is not available or method is called without an object
      return;
    }

    var pushEvent = {
      event: 'umPushed',
      user: userObj
    };

    window.dataLayer.push(pushEvent);
  };

  const gaEvent = function(action, category,label) {
    if (!dataLayerAvailable) {
      console.warn('Tracking DataLayer not available');
      // No reason to do any furhter if dataLayer is not available or method is called without an object
      return;
    }

    var trackData = {
      'event': 'gaEvent',
      'eventSyntax': {
        'action': action,
        'category': category,
        'label': label
      }
    };

    window.dataLayer.push(trackData);
  };

  // Global bindings here

  // Make available on window (namespaced to not conflict with other scripts)
  window.TC = window.TC || {};
  window.TC.userEvent = userEvent;
  window.TC.pushVirtualPage = pushVirtualPage;
  window.TC.gaEvent = gaEvent;
};